'use client';
import { cloneElement, type ReactElement } from 'react';

import { usePageLogger } from '../hooks/usePageLogger';
import { type LogParameters } from '../models';

export interface LoggingEventProps {
  logName: string;
  action: string;
  targetEventName: string;
  params?: LogParameters;
  children: ReactElement;
  onEvent?: (logName: string, params?: LogParameters) => void;
}

export const LoggingEvent = ({
  children,
  logName,
  action,
  targetEventName,
  params = {},
  onEvent,
}: LoggingEventProps) => {
  const logger = usePageLogger();

  type ChildProps = Record<string, unknown>;

  return cloneElement(children, {
    [targetEventName]: (...args: unknown[]) => {
      logger?.event(logName, action, params);
      onEvent?.(logName, params);

      const childProps = children.props as ChildProps;
      const originalHandler = childProps[targetEventName];

      if (typeof originalHandler === 'function') {
        return (originalHandler as (...args: unknown[]) => unknown)(...args);
      }
    },
  });
};
